import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { passNullParameterContextValue, noLoaderContextValue } from '../commonservice/authentication.interceptor';

@Injectable({
  providedIn: 'root'
})

export class JobMilestoneService {
  private headers: HttpHeaders;
  private urlHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.urlHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  }

  getMilestoneStatus(jobId, entityTypeId, isArchive) {
    return this.http.get<any>('Job/GetJobMilestoneStatus?entityTypeId=' + entityTypeId + '&jobId=' + jobId + '&isArchive=' + isArchive)
  }

  getJobTypeDuration(jobTypeId, entityTypeId, isArchive) {
    return this.http.get<any>('Job/GetJobTypeDuration?entityTypeId=' + entityTypeId + '&jobTypeId=' + jobTypeId + '&isArchive=' + isArchive)
  }

  GetNotesDetailsByTaskID(taskId) {
    return this.http.get<any>('ClientProfile/GetNotesDetailsByTaskID?taskId=' + taskId);
  }

  GetNotesDetailsByClientID(clientId, isArchive) {
    return this.http.get<any>('ClientProfile/GetNotesDetailsByClientID?clientId=' + clientId + '&isArchive=' + isArchive);
  }

  GetxeroDetailsByClientID(clientId) {
    return this.http.get<any>('ClientProfile/GetXeroDetailsByClientID?clientId=' + clientId);
  }

  setPinNoteForClient(clientId, noteId, pinNote) {
    return this.http.get<any>('ClientProfile/SetPinNoteClient?clientId=' + clientId + '&noteId=' + noteId + '&pinNote=' + pinNote)
  }

  DeleteJobNotesDoc(documentId, itemId) {
    return this.http.get<any>('ClientProfile/DeleteJobNotesDoc?DocumentId=' + documentId + '&ItemId=' + itemId);
  }

  DeleteNotesFile(documentId) {
    return this.http.get<any>('Job/DeleteNotesFile?documentId=' + documentId, { headers: this.headers })
  }

  GetNotesDocumentByNoteId(noteId) {
    return this.http.get<any>('ClientProfile/GetNotesDocumentByNoteId?noteID=' + noteId);
  }

  DeleteNotesDetailsByTaskID(noteId, taskId) {
    return this.http.get<any>('ClientProfile/DeleteJobTask?taskID=' + taskId + '&noteID=' + noteId);
  }

  ActiveNotesDetailsByTaskID(noteId) {
    return this.http.get<any>('ClientProfile/ActiveJobTask?noteID=' + noteId);
  }

  GetUsers(isArchived) {
    return this.http.get<any>('ClientProfile/GetUsers?isArchived=' + isArchived);
  }

  changeTaskStatus(TaskId, status) {
    return this.http.get<any>('ClientProfile/ChangeTaskStatus?TaskId=' + TaskId + '&status=' + status);
  }

  changeJobSubTaskStatus(SubTaskId, status) {
    return this.http.get<any>('ClientProfile/ChangeJobSubTaskStatus?SubTaskId=' + SubTaskId + '&status=' + status);
  }

  getJobActivity(JobId) {
    return this.http.get<any>('Job/getJobActivity?JobID=' + JobId);
  }

  getJobWorkFlow() {
    return this.http.get<any>('Job/GetAllJobItemsWorkflow');
  }

  getJobWorkFlowJson(flag) {
    return this.http.get<any>('Job/GetAllJobItemsWorkflowJson?IsArchive=' + flag, { headers: this.headers });
  }

  getJobWorkflowJsonV3(flag, startDate, endDate) {
    return this.http.get<any>(`Job/GetAllJobItemsWorkflowJsonV3?filterFromDate=${startDate}&filterToDate=${endDate}&isArchive=${flag}`, { headers: this.headers, context: noLoaderContextValue });
  }

  getJobWorkFlowCustomfield(Id) {
    return this.http.get<any>('Job/getCustomFieldByArea?Id=' + Id);
  }

  getJobWorkFlowVeiw(Id = 0) {
    return this.http.get<any>('Job/GetAllJobWorkflowView?viewId=' + Id);
  }

  getAllJobType() {
    return this.http.get<any>('Job/GetMasterJobTypes');
  }

  getDebtorClient() {
    return this.http.get<any>('Job/GetDebtorClient', { headers: this.headers });
  }

  GetTagdetailssettings() {
    return this.http.get<any>('Settings/GetTagdetailssettings?isArchive=' + false)
  }

  GetJobStatusCatagory() {
    return this.http.get<any>('Job/GetStatusCatagory', { headers: this.headers });
  }

  getJobstatusforJob(jobId) {
    return this.http.get<any>('Job/GetJobStatusforjobId?jobId=' + jobId);
  }

  GetStatusOwnerForJob(jobId) {
    return this.http.get<any>('Job/GetStatusOwnerForJob?jobId=' + jobId);
  }

  GetStatusOwnerList() {
    return this.http.get<any>('Job/GetStatusOwnerList');
  }

  GetDivisionByJobTypeId(jobTypeId: number): Observable<any> {
    return this.http.get<any>(`Job/GetDivisionByJobTypeId?jobTypeId=${jobTypeId}`);
  }

  RemoveCustomField(jobCustomField) {
    return this.http.post<any>('Job/DeactivateCustomFieldForJob', jobCustomField, { headers: this.headers });
  }

  addEditCustomField(customFieldData: any) {
    return this.http.post<any>('Job/AddEditCustomField', customFieldData, { headers: this.headers });
  }

  GetUserShortName() {
    return this.http.get<any>('UserManagement/GetUserShortName');
  }

  UpdateUserCostFlag(IsCostFlag) {
    return this.http.post<any>('Job/UpdateUserJobCostFlag?IsCostFlag=' + IsCostFlag + '', { headers: this.urlHeaders });
  }

  GetJobStatusData(jobId) {
    return this.http.get<any>('Job/GetJobStatusData?jobId=' + jobId);
  }

  GetJoboutstandingWip(jobId) {
    return this.http.get<any>('Job/GetJoboutstandingWip?jobId=' + jobId);
  }

  getJobWorkFlowForGroup() {
    return this.http.get<any>('Job/GetjobworkflowForDebitorClient');
  }

  changeJobStatus(JobId, toStatusId) {
    return this.http.post<any>('Job/ChangeJobStatus/' + JobId + '/' + toStatusId + '', { headers: this.urlHeaders });
  }

  onGetStatusCatKanbonData() {
    return this.http.get<any>('Job/GetAllJobStatusForStausCat');
  }

  onGetStatusCatKanbonDataSet() {
    return this.http.get<any>('Job/GetJobStatusCatDataWithJtype');
  }

  GetJobsDetailsByClientID(clientId) {
    return this.http.get<any>('Billing/GetJobDataBillingList?cid=' + clientId + '');
  }

  GetInvoiveDetailsByClientID(clientId) {
    return this.http.get<any>('Billing/GetAllInvoiceDetailForClient?ClientId=' + clientId + '');
  }

  GetJobsInvByClientID(clientId, flag = null) {
    return this.http.get<any>('Billing/GetInvoiceListDetailForClient?ClientId=' + clientId + '&Flag=' + flag);
  }

  GetCustomFieldDetails(ContextId, ContextType, SectionId) {
    return this.http.get<any>('Job/GetCustomFieldDetails?ContextId=' + ContextId + '&ContextType=' + ContextType + '&SectionId=' + SectionId);
  }

  GetTasksDetails(taskType, Id, JobId, status = '') {
    return this.http.get<any>('ClientProfile/GetTasksDetails?taskType=' + taskType + '&Id=' + Id + '&JobId=' + JobId + '&Status=' + status);
  }

  AddEditTask(taskDetail) {
    return this.http.post<any>('ClientProfile/AddEdit_SubTask', taskDetail, { headers: this.headers });
  }

  Delete_TaskGroup_Task_SubTask(taskType, Id) {
    return this.http.post<any>('ClientProfile/Delete_TaskGroup_Task_SubTask?taskType=' + taskType + '&Id=' + Id, {});
  }

  UpdateSeq_TaskGroup_Task_SubTask(taskType, Id, Sequence, TaskGroupId) {
    return this.http.post<any>('ClientProfile/UpdateSeq_TaskGroup_Task_SubTask?taskType=' + taskType + '&Id=' + Id + '&Sequence=' + Sequence + '&TaskGroupId=' + TaskGroupId, { headers: this.headers });
  }

  UpdateStatusOwner(jobId, statusOwnerId, gridType) {
    return this.http.post<any>('Job/UpdateStatusOwner?jobId=' + jobId + '&statusOwnerId=' + statusOwnerId + '&type=' + gridType, null, { headers: this.headers, context: passNullParameterContextValue });
  }

  AddEditJobTaskNew(taskDetail) {
    return this.http.post<any>('Job/AddEditJobTaskNew', taskDetail, { headers: this.headers });
  }

  GetJobStatusListKanbanboard() {
    return this.http.get<any>('Job/GetJobStatusListKanbanboard');
  }

  getAllTaskList(isShowComplete: boolean | null) {
    let url = isShowComplete !== null ? `Job/GetAllClientActivities/?isShowComplete=${isShowComplete}` : 'Job/GetAllClientActivities/';
    return this.http.get<any>(url);
  }

  GetjobListFilterView(ViewId, clientId) {
    return this.http.get<any>('Job/GetJjobworklflowviewModel?ViewId=' + ViewId + '&clientId=' + clientId);
  }

  getTaskWorkFlowVeiw() {
    return this.http.get<any>('Job/GetAllJobWorkflowTaskView');
  }

  getLodgmentDetails(year) {
    return this.http.get<any>('GetLodgmentDetails?year=' + year);
  }

  GetRecurrenceDetailForFirm() {
    return this.http.get<any>('Job/GetJobRecurrenceDetails');
  }

  deleteJobRecurrence(cId, context) {
    return this.http.get<any>('Job/DeleteJobRecurenceById?contextId=' + cId + '&contextType=' + context, { headers: this.urlHeaders });
  }

  markJobActive(jobId) {
    return this.http.post<any>('Job/ActivateJobRecurenceById?jobId=' + jobId, { headers: this.urlHeaders });
  }

  UpdateJobPriority(jobId, jobpriorityId) {
    return this.http.get<any>('Job/UpdateJobPriority?jobId=' + jobId + '&jobpriorityId=' + jobpriorityId, { headers: this.headers });
  }

  GetJobsUserDetails() {
    return this.http.get<any>('Job/GetUserDetails/', { headers: this.headers })
  }

  getDocDetails(doc) {
    return this.http.get<any>('Document/GetFileFromBlob?docUrl=' + doc, { headers: this.headers })
  }

  getJobWorkflowview(actionId: number) {
    return this.http.get<any>(`Job/GetJobworkflowview?_action=${actionId}`);
  }

  getJobsWorkflowData() {
    return this.http.get<any>('Job/GetJobItemsForDashBoardAsync', { headers: this.headers })
  }

  GetExistingJobDetailsForClient(clientId: any = null) {
    return this.http.get<any>('Job/GetExistingJobDetailsForClient' + (clientId ? `?clientId=${clientId}` : ''));
  }

  BulkUpdateJobAssignee(request) {
    return this.http.post<any>('Job/BulkUpdateJobAssignee', request);
  }

  getJobDetailById(jobId) {
    return this.http.get<any>('Job/GetJobDetailById?jobId=' + jobId);
  }

  getJobDetails(jobId) {
    return this.http.get<any>('Job/GetJobDetail/' + jobId + '');
  }

  GetJobAssignedPartnersAndManagers() {
    return this.http.get<any>('Job/GetJobAssignedPartnersAndManagers');
  }

  getAssigneeDetailsForJob(jobsAssignUser) {
    return this.http.post<any>('Job/GetAssigneeDetailsForjob', jobsAssignUser, { headers: this.headers })
  }

  postBulkAddEditJob(jobsDetail) {
    return this.http.post<any>('Job/PostBulkAddEditJob', jobsDetail, { headers: this.headers })
  }

  getJobTypeByEntityTypeId(entityTypeId) {
    return this.http.get<any>('Job/GetJobTypeByEntityId?entityTypeId=' + entityTypeId, { headers: this.urlHeaders })
  }

  getDocumentforDownloadbyId(id) {
    return this.http.get('Job/GetDocumentforDownloadbyId?ContextId=' + id + '&ContextName=Notes');
  }

  getAffectedTaskCount(jobid, contextType, taskId, dueDate, mode) {
    return this.http.get<any>('Job/GetAffectedTaskCount/' + jobid + '/' + contextType + '/' + taskId + '/' + dueDate + '/' + mode);
  }

  getJobDivisionByClientCode(clientCode: any) {
    return this.http.get<any>(`Job/GetJobDivisionByClientCode?clientCode=${clientCode}`, { headers: this.headers });
  }

  getUnAssignedUser() {
    return this.http.get<any>('Job/GetUnAssignedUser/', { headers: this.headers });
  }

  addEditJob(formData: FormData) {
    const headers: HttpHeaders = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    return this.http.post<any>('Job/AddEditJob', formData, { headers: headers })
  }

  GetAllJobTasksForAutomation(JobId, taskCategory = 1, ignoreJobCategory = true) {
    return this.http.get<any>('Job/GetAllJobTaskGroupbyJobId?jobId=' + JobId + '&taskCategory=' + taskCategory + '&ignoreJobCategory=' + ignoreJobCategory);
  }

  GetJobTypeByEntityId(entityId) {
    return this.http.get<any>('Job/GetJobTypeByEntityTypeId?entityTypeId=' + entityId)
  }

  GetJobs(entityTypeId, jobTypeId) {
    return this.http.get<any>('Job/GetJobTypeStatus/' + entityTypeId + '/' + jobTypeId + '')
  }

  UpdateCompletionStatusTrigger(typeId: string, statusId: string, isTrigger: boolean) {
    return this.http.get<number>('Job/UpdateCompletionStatusTrigger?typeId=' + typeId + '&statusId=' + statusId + '&isTrigger=' + isTrigger);
  }

  DeleteJobTypeStatus(id: string, isDeleted: boolean) {
    return this.http.get<number>('Job/DeleteJobTypeStatus?statusId=' + id + '&isDeleted=' + isDeleted);
  }

  GetSingleJobTypeStatus(id: string) {
    return this.http.get<any>('Job/GetSingleJobTypeStatus?statusId=' + id);
  }

  activedeactiveJobTypeStatus(id: string, isDeleted: boolean) {
    return this.http.get<number>('Job/DeleteJobTypeStatus?statusId=' + id + '&isDeleted=' + isDeleted);
  }

  PostJobTypeStatus(data) {
    return this.http.post<any[]>('Job/PostJobTypeStatus', data, { headers: this.headers })
  }

  PostJobStatusSequences(data) {
    return this.http.post<any[]>('Job/PostJobStatusSequences', data, { headers: this.headers })
  }

  GetJobType() {
    return this.http.get<any>('Job/GetAllActiveJobTypes')
  }

  GetStatusName() {
    return this.http.get<any>('Job/GetStatusList')
  }

  GetUnAssignJobUsers(jobId) {
    return this.http.get<any>('Job/GetUnAssignJobUsers?jobId=' + jobId, { headers: this.headers })
  }

  AddStaffDetail(jobsAssignUser) {
    return this.http.post<any>('Job/AddStaffDetail', jobsAssignUser, { headers: this.headers })
  }

  GetAssigneeDetailsForjobEdit(JobId) {
    return this.http.get<any>('Job/GetAssigneeDetailsForjobEdit/' + JobId + '', { headers: this.headers })
  }

  getCustomFieldByArea(Id, mode) {
    return this.http.get<any>('Job/getCustomFieldByArea?Id=' + Id + '&Mode=' + mode);
  }

  GetPeriodDetailForFirm() {
    return this.http.get<any>('Job/GetPeriodDetailForFirm');
  }

  GetJobInvoiceNarration(JobIds) {
    return this.http.get<any>('Job/GetJobInvoiceNarration?JobIds=' + JobIds);
  }

  GetActualCostDataforWidget(_jobId) {
    return this.http.get<any>('Job/GetActualCostDataforWidget/' + _jobId + '', { headers: this.headers })
  }

  UpdateAssigneeUserforJob(jobsAssignUser) {
    return this.http.post<any>('Job/UpdateAssigneeUserforJob', jobsAssignUser, { headers: this.headers })
  }

  GetAllJobTaskAssigneeforjobEdit(jobId) {
    return this.http.get<any>('Job/GetAllJobTaskAssigneeforjobEdit/' + jobId + '', { headers: this.headers })  // this API call we can replace with  [Route("GetAllJobTaskAssigneeforjobEdit/{jobId}")]. here this will give you two composite list a.) lstJobAssigneeDetails, b.) lstTaskAssigneeDetails, so here lstJobAssigneeDetails we can use for existing.
  }

  GetCustomFieldsByRole(sId, JobId: any) {
    return this.http.get<any>('Job/GetCustomFieldsByRole?Id=' + sId + '&JobId=' + JobId);
  }

  getRolesForCustomField(Id: number) {
    return this.http.get<any>(`Job/GetRolesforCustomFields?Id=${Id}`);
  }

  getCustomFieldsListById(Id: number) {
    return this.http.get<any>(`Job/GetCustomFieldsList?Id=${Id}`);
  }

  getArchiveCustomFieldsById(Id: number) {
    return this.http.get<any>(`Job/ArchiveCustomField?Id=${Id}`);
  }

  getEditCustomFieldsById(Id: number) {
    return this.http.get<any>(`Job/EditCustomField?Id=${Id}`);
  }

  getCustomFieldHeader() {
    return this.http.get<any>(`Job/GetCustomFieldHeader`);
  }

  updateCustomFieldHeader(payload: any) {
    return this.http.post<any>(`Job/UpdateHeaderforCustomFields`, payload, { headers: this.headers });
  }

  editJobworkflowview(tileviews) {
    return this.http.post<any>('Job/editJobworkflowview', tileviews, { headers: this.headers })
  }

  getActualCostDataforWidget(jobId: number) {
    return this.http.get<any>(
      `Job/GetActualCostDataforWidget/${jobId}`
    );
  }

  getUserJobCostDetails() {
    return this.http.get<any>('Job/GetUserJobCostDetails');
  }

  getActiveStatusList() {
    return this.http.get<any>('Job/GetActiveStatusList');
  }

  archiveJob(jobId: number, flag: boolean) {
    return this.http.get<any>(
      `Job/ArchiveJob?JobId=${jobId}&ArchiveValue=${flag}`
    );
  }

  getJobsDocumentList(jobId) {
    return this.http.get<any>('Job/GetJobsDocumentList?jobId=' + jobId + '')
  }

  getCustomFieldTiles(contextId: number, contextType: string) {
    const params = {
      contextId: contextId,
      contextType: contextType
    };

    return this.http.get<any>('Job/GetCustomFieldTiles', { params });
  }

  getJobsList(clientId: number, flag: boolean) {
    return this.http.get<any>(
      `Job/GetJobsList?clientId=${clientId}&IsArchive=${flag}`
    );
  }

  getJobTypeStatusList(entityTypeId: number, jobTypeId: number) {
    return this.http.get<any>(
      `Job/GetJobTypeStatusList/${entityTypeId}/${jobTypeId}`
    );
  }

  updateDocumentDetail(data: any) {
    return this.http.post<any>(
      'Job/DocumentDetailUpdate',
      data,
      { headers: this.headers }
    );
  }

  getClientsDocumentList(clientId: number, flag: string) {
    return this.http.get<any>(`Job/GetClientsDocumentList?clientId=${clientId}&flag=${flag}`);
  }

  getAllUserForJobDoc(docId: number) {
    return this.http.get<any>(`Job/GetAllUserForJobDoc?docId=${docId}`);
  }

  getJobsTags(JobIds: string) {
    return this.http.get<any>(`Job/GetJobsTags?JobIds=${JobIds}`);
  }
  getCustomFieldByAreaNew(Id:number, showIn:number) {
    return this.http.get<any>('Job/GetCustomFieldByAreaNew?Id=' + Id + '&showIn=' + showIn);
  }
  getGridCustomFieldByArea(Id) {
    return this.http.get<any>('Job/GetGridCustomFieldByArea?Id=' + Id);
  }
}
